import React from 'react'
import './navbar.css'
import { IoMailUnread } from "react-icons/io5";
import { MdNotificationsActive } from "react-icons/md";
import { AiOutlineSearch } from "react-icons/ai";
import Search from '../Search/Search';
import { BsPersonCircle } from 'react-icons/bs';

const Navbar = ({tabtext, currentab}) => {
  return (
    <div className='dashboard-top-navbar'>
        {currentab === 'dashboard' ? <div className='dtn-left-container'>
          <span>{tabtext}</span>
          <span>Measure How Fast you’re Growing Monthly Recurring performance management</span>
        </div>:<div className='dtn-left-container'>
          <span>{tabtext}</span>
          <span></span>
        </div>}

        {currentab === 'dashboard' && <Search />}

        <div className='dtn-right-container'>
          <IoMailUnread id='dtn-icons'/>
          <MdNotificationsActive id='dtn-icons'/>
          <BsPersonCircle id='dtn-icons'/>
        </div>
      </div>
  )
}

export default Navbar